<svelte:options customElement="hb-skeleton-component" />

<script lang="ts">
  import type { Component } from "./types/webcomponent.type";

  let {
    id = "",
    string = "",
    json = "{}",
    boolean = false,
  }: Component = $props();

  // derived example
  let upperCaseString = $derived(string ? string.toUpperCase() : "");

  // derived.by example (complex logic)
  let parsedJson = $derived.by(() => {
    if (typeof json === "object") return json;
    try {
      return JSON.parse(json || "{}");
    } catch {
      return {};
    }
  });

  // derived.by example (boolean normalization)
  let isActive = $derived.by(() => {
    const b = boolean as unknown;
    return (
      b === true ||
      b === "true" ||
      b === "yes" ||
      b === "" ||
      b === "1"
    );
  });

  function dispatchEvent() {
    $host().dispatchEvent(new CustomEvent("event", { detail: { test: true } }));
  }
</script>

<div {id} class="skeleton-root" part="testpart">
  <p>String: {string}</p>
  <p>Upper: {upperCaseString}</p>
  <p>Boolean: {isActive}</p>
  <p>JSON keys: {Object.keys(parsedJson).join(", ")}</p>

  <button type="button" class="button is-primary" onclick={dispatchEvent}>
    Dispatch Event
  </button>

  <slot name="content">Default slot content</slot>
</div>

<style lang="scss">
  @forward "./styles/bulma.scss";
  @forward "./styles/webcomponent.scss";
</style>
